export default "__VITE_ASSET__BYnfSg0D__"